import { Fragment, useCallback, useEffect } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import H2 from 'UIComponents/elements/headings/H2';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import VersionHistoryPanel from 'marketplace-ui-assets-core/versions/components/VersionHistoryPanel';
import { registerVersionHistoryQuery } from 'marketplace-ui-assets-core/versions/queries/versionHistoryQuery';
import { getVersionHistory } from '../../clients/ecosystemClient';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SUBSCREEN = 'version history panel';
const GET_VERSION_HISTORY = registerVersionHistoryQuery(getVersionHistory);
export default function AssetVersionHistoryModalPanel({
  offeringId,
  onClose,
  onTrackInteraction,
  onTrackPageview
}) {
  const handleClose = useCallback(() => {
    onClose();
    onTrackInteraction('close version history panel', {
      subscreen: SUBSCREEN
    });
  }, [onClose, onTrackInteraction]);
  useEffect(() => {
    onTrackPageview({
      subscreen: SUBSCREEN
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/_jsx(VersionHistoryPanel, {
    errorMessage: unescapedText(`marketplace-assets-ui.details.assetInfo.versionHistoryPanel.error`),
    offeringId: offeringId,
    panelHeader: /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.details.assetInfo.versionHistory"
        })
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: handleClose
      })]
    }),
    panelFooter: /*#__PURE__*/_jsx(UIButton, {
      use: "tertiary-light",
      onClick: handleClose,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.details.assetInfo.versionHistoryPanel.close"
      })
    }),
    versionHistoryQuery: GET_VERSION_HISTORY
  });
}